import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';

import { BillingCycle } from '$/GraphQL/schema/types';

export const SubscriptionNote: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <span className='border rounded-md border-coral-1 text-coral-1 leading-relaxed px-1/2e inline-block md:whitespace-nowrap text-sm'>
    {children}
  </span>
);

export const Per: React.FC<{ className?: string; billingCycle?: BillingCycle; unit?: string }> = ({
  className,
  unit,
  billingCycle,
}) => (
  <span className={className} css={tw`text-xs`}>
    /{unit ?? (billingCycle === BillingCycle.Year ? 'year' : 'month')}
  </span>
);

export const PriceBar: React.FC<{ price: string; billingCycle: BillingCycle }> = ({
  price,
  billingCycle,
}) => {
  return (
    <span
      css={css`
        color: #fff;
        padding: 0.5rem 1rem;
        position: absolute;
        font-size: 1.5rem;
        bottom: 0px;
        right: 0px;
        left: 0px;
        z-index: 2;
        background: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(2px);
      `}
    >
      {price}
      <Per className='text-sm' billingCycle={billingCycle} />
    </span>
  );
};
